import { Quote } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";

export const Testimonials = () => (
  <section className="section border-t border-white/[0.08]" data-testid="testimonials-section">
    <div className="container-x">
      <Reveal as="p" className="eyebrow">
        Client stories
      </Reveal>
      <Reveal
        delay={0.1}
        className="relative mt-8 overflow-hidden rounded-2xl border border-dashed border-white/15 bg-white/[0.012] px-6 py-16 sm:px-12 sm:py-24"
      >
        <Quote className="absolute -right-6 -top-6 h-40 w-40 text-[#2DD4D4]/10 sm:h-56 sm:w-56" strokeWidth={1} aria-hidden="true" />
        <h2
          className="relative max-w-xl text-3xl font-semibold leading-[1.05] tracking-[-0.035em] sm:text-5xl"
          data-testid="testimonials-empty-state"
        >
          Client stories coming soon.
        </h2>
        <p className="relative mt-5 max-w-lg leading-relaxed text-[#A1A1AA]">
          We're a new studio, so we won't fill this space with made-up reviews. Real words from real North Jersey
          businesses will live here as projects launch.
        </p>
        <div className="relative mt-12 grid gap-4 sm:grid-cols-3" aria-hidden="true">
          {[0, 1, 2].map((i) => (
            <div key={i} className="hatch rounded-xl border border-white/[0.06] p-5">
              <div className="h-2 w-4/5 rounded bg-white/10" />
              <div className="mt-2 h-2 w-3/5 rounded bg-white/10" />
              <div className="mt-6 flex items-center gap-2">
                <span className="h-7 w-7 rounded-full bg-white/[0.06]" />
                <span className="h-2 w-16 rounded bg-white/10" />
              </div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
